import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import _ from 'lodash';
Vue.use(Router);
const multibookConfig = require(`../../package.json`).config;

let config = [];

if (multibookConfig.external) {
  config = [
    {
      path: '/',
      name: 'main-view',
      props: { multibookType: `${multibookConfig.type}` },
      component: require('@/components/HomePage/HomePage').default,
    },
    {
      path: '/game/:id',
      name: 'game',
      component: require('@/components/TrGame/v4/TrGame').default,
      beforeEnter(to, from, next) {
        try {
          store.commit('CHANGE_MULTIBOOK_TYPE', store.getters.multibookType);
          let gameObj = store.getters[`${_.upperFirst(store.getters.multibookType)}/gameByID`](to.params.id);
          if (gameObj && _.isArray(gameObj.items)) {
            store.commit('CHANGE_GAME_TYPE', 'multiStage');
            store.dispatch('setGameObject', gameObj);
            if (gameObj.multiStageShuffle && gameObj.multiStagePick != 0) {
              store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
              store.commit('SET_GAME_OBJ_ITEMS', gameObj.items);
              store.commit('PICK_GAMEOBJECT', gameObj.multiStagePick);
            } else if (gameObj.multiStageShuffle) {
              store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
              store.commit('SHUFFLE_GAMEOBJECT', _.shuffle(store.getters.gameObj.items));
            }
          } else {
            store.commit('CHANGE_GAME_TYPE', 'singleStage');
            store.commit('CHANGE_GAME_ACTIVE', true);
            store.commit('CHANGE_GAME_TYPE', 'singleStage');
          }
          console.log('gameObj', gameObj);
          store.dispatch('newGame', gameObj);
        } catch (error) {
          router.push('/');
        }

        next();
      },
    },

    {
      path: '/page/presentations',
      name: 'presentations-view',
      props: false,
      component: require('@/components/MbPresentationsGrid/MbPresentationsGridElectron').default,
    },
    {
      path: '/monograph',
      name: 'monograph-view',
      props: true,
      component: require('@/components/MbMonograph/MbMonograph').default,
    },
    {
      path: '/grid',
      name: 'grid-view',
      props: true,
      component: require('@/components/GridView/MbGrid/MbGrid').default,
    },
    {
      path: '/config-cjs',
      name: 'config-cjs-view',
      props: true,
      component: require('@/components/MpConfigCreateJS/MpConfigCreateJS').default,
    },
    {
      path: '/page/grid',
      name: 'presentations-grid-view',
      props: false,
      component: require('@/components/MbPresentationsGrid/MbPresentationsGridElectron').default,
    },
    {
      path: '/unit/:uid',
      name: 'one-unit-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzNextGrid').default,
    },
    {
      path: '/units',
      name: 'units-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzGrid').default,
    },
    {
      path: '/festivals',
      name: 'festivals-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzNextGrid').default,
    },
    {
      path: '/karty',
      name: 'karty-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzNextGrid').default,
    },
    {
      path: '/karta/:page/:uid/:slide?',
      name: 'karty-slider-view',
      props: true,
      component: require('@/components/PsGallery/PsGallery').default,
    },
    {
      path: '/plakaty',
      name: 'plakaty-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzNextGrid').default,
    },
    {
      path: '/nagrania',
      name: 'nagrania-grid-view',
      props: true,
      component: require('@/components/PsMusic/PsMusicView').default,
    },
    {
      path: '/revise',
      name: 'revise-grid-view',
      props: true,
      component: require('@/components/MzGrid/MzNextGrid').default,
    },
    {
      path: '/page/games',
      name: 'games-grid-view',
      props: true,
      component: require('@/components/MbGamesGrid/MbGamesGridElectron').default,
    },
    {
      path: '/page/game',
      name: 'game-view',
      props: true,
      component: require('@/components/GridView/MbGame/MbGame').default,
    },
    {
      path: '/presentation/by/id/:presentationid',
      name: 'presentation-by-id',
      props: true,
      component: require('@/components/MbPresentation/MbPresentation').default,
    },
    {
      path: '/game/by/id/:gameid',
      name: 'game-by-id',
      props: true,
      component: require('@/components/GridView/MbGame/MbGame').default,
    },
    {
      path: '/page/songs',
      name: 'songs-view',
      props: false,
      component: require('@/components/MzSongsList/MzSongsList').default,
    },
    {
      path: '/page/error',
      name: 'error',
      props: false,
      component: require('@/components/MbErrorPage/ErrorPage').default,
    },
    {
      path: '/page/:id',
      name: 'page-view',
      props: true,
      component: require('@/components/MainView/MainView').default,
    },
    {
      path: '/main_book',
      name: 'main_book-view',
      props: true,
      component: require('@/components/HomePage/HomePage').default,
    },
    {
      path: '/presentation/:id',
      name: 'presentation',
      component: require('@/components/MbPresentation/MbPresentation').default,
    },
    {
      path: '*',
      redirect: '/',
    },
  ];
  for (const item of multibookConfig.external) {
    let add = [
      {
        path: `/${item}`,
        name: `${item}-view`,
        props: { multibookType: `${item}` },
        component: require('@/components/MainView/MainView').default,
      },
    ];
    config = [...config, ...add];
  }
} else {
  config = [
    {
      path: '/',
      name: 'main-view',
      props: { multibookType: `${multibookConfig.type}` },
      component: require('@/components/MainView/MainView').default,
    },
    {
      path: '/page/presentations',
      name: 'presentations-view',
      props: false,
      component: require('@/components/MbPresentationsGrid/MbPresentationsGridElectron').default,
    },
    {
      path: '/page/grid',
      name: 'presentations-grid-view',
      props: false,
      component: require('@/components/MbPresentationsGrid/MbPresentationsGridElectron').default,
    },
    {
      path: '/page/songs',
      name: 'songs-view',
      props: false,
      component: require('@/components/MzSongsList/MzSongsList').default,
    },
    {
      path: '/page/error',
      name: 'error',
      props: false,
      component: require('@/components/MbErrorPage/ErrorPage').default,
    },
    {
      path: '/page/:id',
      name: 'page-view',
      props: true,
      component: require('@/components/MainView/MainView').default,
    },
    {
      path: '/presentation/:id',
      name: 'presentation',
      component: require('@/components/MbPresentation/MbPresentation').default,
      beforeEnter(to, from, next) {
        try {
          if (!store.getters.getPresentationConfig) {
            store.commit(
              'STATE_PRESENTATION_CONFIG',
              store.getters[`${_.upperFirst(store.getters.multibookType)}/presentationByID`](to.params.id).item
            );
            store.commit('STATE_PRESENTATION_SHOW', true);
          }
        } catch (error) {
          router.push('/');
        }

        next();
      },
    },
    {
      path: '/game/:id',
      name: 'game',
      component: require('@/components/TrGame/v4/TrGame').default,
      beforeEnter(to, from, next) {
        try {
          store.commit('CHANGE_MULTIBOOK_TYPE', store.getters.multibookType);
          let gameObj = store.getters[`${_.upperFirst(store.getters.multibookType)}/gameByID`](to.params.id);
          if (gameObj && _.isArray(gameObj.items)) {
            store.commit('CHANGE_GAME_TYPE', 'multiStage');
            store.dispatch('setGameObject', gameObj);
            if (gameObj.multiStageShuffle && gameObj.multiStagePick != 0) {
              store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
              store.commit('SET_GAME_OBJ_ITEMS', gameObj.items);
              store.commit('PICK_GAMEOBJECT', gameObj.multiStagePick);
            } else if (gameObj.multiStageShuffle) {
              store.commit('SET_MULTISTAGE_SHUFFLE', gameObj.multiStageShuffle);
              store.commit('SHUFFLE_GAMEOBJECT', _.shuffle(store.getters.gameObj.items));
            }
          } else {
            store.commit('CHANGE_GAME_TYPE', 'singleStage');
            store.commit('CHANGE_GAME_ACTIVE', true);
            store.commit('CHANGE_GAME_TYPE', 'singleStage');
          }
          console.log('gameObj', gameObj);
          store.dispatch('newGame', gameObj);
        } catch (error) {
          router.push('/');
        }

        next();
      },
    },
    {
      path: '*',
      redirect: '/',
    },
  ];
}
const router = new Router({
  mode: 'history',
  routes: config,
});
// router.replace({ path: '*', redirect: '/' });
export default router;
